import styled from 'styled-components';
import createExtractCssFromProps from 'style-utils/createExtractCssFromProps';
import {
  withPadding,
  withMargin,
  WithMarginProps,
  WithPaddingProps,
  withTabletPadding,
  WithTabletPaddingProps,
  withDesktopPadding,
  WithDesktopPaddingProps,
} from 'style-utils/dimensionsMixins';

export type FlexProps = WithMarginProps &
  WithTabletPaddingProps &
  WithDesktopPaddingProps &
  WithPaddingProps & {
    inline?: boolean;
    justify?: CSSJustifyContent;
    align?: CSSAlignItems;
    alignContent?: CSSAlignContent;
    flexDirection?: CSSFlexDirection;
    flexWrap?: CSSFlexWrap;
    fluid?: boolean;
    fluidHeight?: boolean;
    hidden?: boolean;
    overflow?: CSSOverflow;
    backgroundStyle?: string;
    gap?: string;
  };

/**
 * Renders a flexbox container whose flex properties
 * can be controlled via props.
 * Use "as" prop to change the rendered "Element".
 * @see https://styled-components.com/docs/api#as-polymorphic-prop
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout
 */
export const Flex = styled.div<FlexProps>`
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  ${withPadding};
  ${withMargin};

  ${({ fluid, fluidHeight, gap }): string => {
    let output: string = '';

    if (fluid) {
      output += 'width: 100%;';
    }

    if (fluidHeight) {
      output += 'height: 100%;';
    }
    if (gap) {
      output += `gap: ${gap};`;
    }

    return output;
  }};

  ${createExtractCssFromProps({
    justify: 'justify-content',
    align: 'align-items',
    alignContent: 'align-content',
    flexDirection: 'flex-direction',
    flexWrap: 'flex-wrap',
    overflow: 'overflow',
  })}

  ${withTabletPadding};
  ${withDesktopPadding};
`;
Flex.defaultProps = {
  inline: false,
};

if (!import.meta.env.PROD) {
  Flex.displayName = 'Flex';
}
